// extracted by mini-css-extract-plugin
export default {"glossaryDetailsErrorBlock":"style_glossaryDetailsErrorBlock__nFY6x"};